import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const ExclamationIcon = ({
  color = 'black',
  width = 5,
  marginRight,
  marginLeft,
  containerSize,
  title,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    width={width}
    title={title}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 18" preserveAspectRatio="xMidYMid">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M4.106 11.904L4.721 0H.307l.615 11.904h3.184zM2.514 18C4.022 18 5 16.975 5 15.609c-.028-1.42-1.006-2.391-2.486-2.391-1.48 0-2.514.972-2.514 2.39C0 16.976 1.006 18 2.486 18h.028z"
      />
    </svg>
  </DefaultIconWrapper>
);
